import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DragScrollComponent } from 'ngx-drag-scroll';
import { CoreService } from 'src/app/core/services/core.service';
import { SplashScreenComponent } from 'src/app/shared/components/splash-screen/splash-screen.component';

@Component({
  selector: 'bs-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {

  @ViewChild('articleScroll', {read: DragScrollComponent}) ads: DragScrollComponent;
  @ViewChild('instagramScroll', {read: DragScrollComponent}) ids: DragScrollComponent;
  @ViewChild('eventScroll', {read: DragScrollComponent}) eds: DragScrollComponent;

  public carouselDataTop = {
    items: []
  };

  public carouselData = {
    items: []
  };

  public screenWidth: any;
  public currentDateTime = new Date().toISOString();

  currentSlideShow = 0;

  constructor(
    public coreService: CoreService,
    public dialog: MatDialog,
  ) {
    this.screenWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = event.target.innerWidth;
  }

  ngOnInit() {
    this.openSplashScreen();

    // tslint:disable-next-line:max-line-length
    this.coreService.fetchData('articles/?limit=15&filter[headline_article][eq]=1&sort=-published_date_time,position', true)
    .subscribe((data) => {
      this.carouselData.items = [];
      for (let i = 0; i < data.length; i++) {
        const item = {
          image: data[i].image ? this.coreService.getCompressedImage(data[i].image.data.url) : '',
          imageBackgroundPosition: data[i].imageBackgroundPosition,
          video: data[i].video ? data[i].video.data.url : '',
          mobileImage: data[i].mobileImage ? this.coreService.getCompressedImage(data[i].mobileImage.data.url) : null,
          mobileImageBackgroundPosition: data[i].mobileImageBackgroundPosition,
          title: data[i].title,
          subTitle: data[i].subTitle,
          link: `/article/${data[i].id}/${data[i].handle}`,
        };
        if (i === 0) {
          this.carouselDataTop.items.push(item);
        } else {
          this.carouselData.items.push(item);
        }
      }
    });
  }

  draging(e) {
    console.log(e);
  }

  openSplashScreen(): void {
    this.coreService.fetchData('settings/').subscribe((data) => {
      const splashSettingEnabled = data.findIndex((x) => x.key === 'show_splash_page' && x.value === 'true') !== -1;
      const splashSettingTtl = data.find((x) => x.key === 'splash_ttl' && x.value)['value'];
      const splashSettingExpiry = data.find((x) => x.key === 'splash_expiry' && x.value)['value'];
      const splashSettingBackground = data.find((x) => x.key === 'splash_page_background' && x.image)['image']['data']['fullUrl'];
      const splashShownValue = localStorage.getItem('splashShown');
      const splashShown = JSON.parse(splashShownValue);
      if (!splashSettingEnabled) {
        console.log('Splash not enabled');
        return;
      }
      if (!splashShown || Date.now() > splashShown.expiry) {
        const dialogRef = this.dialog.open(SplashScreenComponent, {
          panelClass: 'full-screen-dialog',
          data: {
            ttl: splashSettingTtl,
            background: splashSettingBackground,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result && result.link) {
            this.coreService.routeToWithType(result.link);
          }
          console.log('The dialog was closed', result);
          localStorage.setItem('splashShown', JSON.stringify({
            expiry: Date.now() + (splashSettingExpiry ? (parseInt(splashSettingExpiry, 10) * 1000) : 60000),
            expiryValue: (splashSettingExpiry ? (parseInt(splashSettingExpiry, 10) * 1000) : 60000)
          }));
        });
      }
    });
  }

  moveLeft() {
    this.ids.moveLeft();
  }

  moveRight() {
    this.ids.moveRight();
  }

  moveTo(index) {
    this.ids.moveTo(index);
  }

  startSlideShow(ds, interval = 5000) {
    return setInterval(() => {
      if (ds) {
        if (ds.currIndex + 1 < ds.indexBound) {
          ds.moveTo(ds.currIndex + 1);
        } else {
          ds.moveTo(0);
        }
      }
    }, interval);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.startSlideShow(this.ads, 10000);
      this.startSlideShow(this.ids);
    }, 5000);
  }

  public goTo(url) {
    document.location = url;
  }

  public hasNext() {
    console.log('idx', this.ads.currIndex);
    return true;
    // return this.ads.currIndex ? this.ads.currIndex < this.carouselData.items.length - 1 : false;
  }

  public hasPrevious() {
    return true;
    // return this.ads.currIndex ? this.ads.currIndex > 0 : false;
  }

  public next() {
    this.ads.moveRight();
    // this.currentPosition++;
    // this.currentMargin = this.currentPosition * 100;
  }

  public previous() {
    this.ads.moveLeft();
    // this.currentPosition--;
    // this.currentMargin = this.currentPosition * 100;
  }

  public getImage(item) {
    if (!item) {
      return '';
    }
    const image = this.screenWidth <= 640 && item.mobileImage
      ? item.mobileImage
      : item.image;
    return image;
  }
}
